// 模板 14：跨境电商与供应链服务平台

export default {
  home: {
    banners: [
      {
        img: require('@/assets/img/banner2.jpg'),
        path: '',
        title: '跨境电商一站式服务平台',
        content:
          '整合选品、物流、支付与合规服务，助力卖家轻松出海。'
      },
      {
        img: require('@/assets/img/banner_1.jpg'),
        path: '',
        title: '多平台店铺统一管理',
        content:
          '支持主流跨境平台店铺集中管理与数据分析。'
      }
    ],
    bigData: {
      img: require('@/assets/img/about_img.png'),
      title: '跨境业务数据中心',
      subtitle: '/ Cross-border Data Center',
      paragraphs: [
        '围绕选品、订单与物流各环节构建数据模型，帮助卖家掌握经营状况。',
        '支持按国家、平台与店铺等维度拆解指标，为精细运营提供依据。'
      ],
      buttonText: '咨询出海方案'
    },
    contact: {
      title: '跨境卖家的数字化伙伴',
      subTitle: '用技术与服务帮助中国品牌走向全球',
      buttonText: '联系顾问'
    },
    customers: [],
    advantages: []
  },
  company: {
    name: '海桥跨境科技有限公司',
    aboutImg: require('@/assets/img/about_img.png'),
    paragraphs: [
      '__COMPANY_NAME__专注跨境电商与供应链服务，提供从工具到运营的一体化服务体系。',
      '我们希望让更多中小卖家享受到专业服务与数字化工具带来的红利。'
    ]
  },
  news: [
    {
      id: 'CB01',
      title: '多平台订单同步系统上线',
      introduce:
        '支持亚马逊、eBay 等多平台订单与库存同步管理。',
      date: '03-12',
      year: '2024'
    },
    {
      id: 'CB02',
      title: '推出跨境税务合规模块',
      introduce:
        '帮助卖家管理不同国家的税务申报与合规需求。',
      date: '11-01',
      year: '2023'
    },
    {
      id: 'CB03',
      title: '跨境物流线路智能推荐功能上线',
      introduce:
        '根据时效与成本为订单推荐最优物流线路组合。',
      date: '07-25',
      year: '2023'
    },
    {
      id: 'CB04',
      title: '举办跨境选品与品牌出海沙龙',
      introduce:
        '联合多家品牌与服务商分享跨境运营经验。',
      date: '10-19',
      year: '2022'
    },
    {
      id: 'CB05',
      title: '与海外仓服务商达成战略合作',
      introduce:
        '为卖家提供更加灵活的履约方式和库存管理策略。',
      date: '05-08',
      year: '2022'
    }
  ],
  software: {
    smartTown: {
      title: '跨境店铺与订单管理系统',
      sections: [
        {
          heading: '1. 多店铺集中管理',
          content:
            '统一管理多个平台与店铺的产品、价格与库存。'
        },
        {
          heading: '2. 订单与物流跟踪',
          content:
            '集中查看订单状态与物流轨迹，减少平台切换。'
        },
        {
          heading: '3. 客户与售后管理',
          content:
            '记录跨境客户信息与售后处理情况，提升服务质量。'
        },
        {
          heading: '4. 财务对账',
          content:
            '支持订单、费用与结算数据对账，降低财务工作量。'
        }
      ]
    },
    bigData: {
      title: '跨境运营数据分析平台',
      sections: [
        {
          heading: '1. 国家与市场表现',
          desc:
            '按国家与区域分析销售表现，识别高潜力市场。'
        },
        {
          heading: '2. 平台与店铺比较',
          desc:
            '对比不同平台与店铺的流量与转化情况，指导资源投入。'
        },
        {
          heading: '3. 物流与时效分析',
          desc:
            '统计不同线路的签收时效与异常率，为物流策略提供依据。'
        },
        {
          heading: '4. 毛利与费用结构',
          desc:
            '分析毛利与平台费用、物流成本等构成，帮助卖家健康运营。'
        }
      ]
    }
  },
  services: [
    {
      id: 'section-1',
      title: '跨境运营咨询',
      engTitle: 'Cross-border Consulting',
      img: require('@/assets/img/service1.jpg')
    },
    {
      id: 'section-2',
      title: '系统接入与培训',
      engTitle: 'System Onboarding',
      img: require('@/assets/img/service2.jpg')
    },
    {
      id: 'section-3',
      title: '物流与海外仓解决方案',
      engTitle: 'Logistics Solution',
      img: require('@/assets/img/service3.jpg')
    },
    {
      id: 'section-4',
      title: '品牌出海顾问',
      engTitle: 'Brand Go-global',
      img: require('@/assets/img/service4.jpg')
    }
  ],
  job: {
    title: '跨境电商产品运营',
    responsibilities: [
      '负责跨境工具产品的运营与用户增长；',
      '与卖家深入沟通，挖掘产品优化机会；',
      '参与运营活动策划与执行。'
    ],
    requirements: [
      '有跨境电商从业经验或服务商背景优先；',
      '善于沟通，具备数据分析能力；',
      '对跨境电商与品牌出海有兴趣。'
    ],
    buttonText: '立即加入'
  }
};





// WEBPACK FOOTER //
// ./src/config/templates-14.js